import { LocalService } from './../../storage/localService';
import { SessionStorageService } from './../../storage/sessionStorage.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AccesoService } from '../../acceso/acceso.service';
import { FiltrosDeudas } from '../../../models/FiltrosDeudas';
import { Deudas } from '../../../models/Deudas';
import { filter, pluck } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class DeudasService{

    message: Observable<any>;
    readonly urlBase = environment.rutaBase;
    header : HttpHeaders;
    idEmpresa_Factor : any;

    constructor(private http : HttpClient,  
                private accesoService :AccesoService,
                private sessionStorageService: SessionStorageService,
                private localService : LocalService){
        this.header = this.accesoService.desencriptarTOKEN()
        this.datoStorage()
    }

    datoStorage(){
        this.message = this.sessionStorageService.storageChange$.pipe(
          filter(({ storageArea }) => storageArea === "sessionStorage"),
          filter(({ key }) => key === '1cefada07eb9',),
          pluck("value")
        );
       this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
       if (this.idEmpresa_Factor == undefined) {
        this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
       } 
      }

    filtroListadoDeudas(filtros : FiltrosDeudas){
        
        let headers = this.header;
        return this.http.get(`${this.urlBase}/Deudas?idEmpresa_Factor=${this.idEmpresa_Factor}&idEmpresa=${filtros.idEmpresa}&Estado=${filtros.Estado}&Moneda=${filtros.Moneda}&FechaIni=${filtros.FechaIni}&FechaFin=${filtros.FechaFin}`,{headers});
    }
  
    crearDeudas(body : Deudas){
      
        let headers = this.header;
        return this.http.post(`${this.urlBase}/Deuda?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
    }

    actualizarDeudas(body : Deudas){
        
        let headers = this.header;
        return this.http.put(`${this.urlBase}/Deuda?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
    }

    bajaDeuda(body : any){
      
        let headers = this.header;
        return this.http.put(`${this.urlBase}/Deuda/Estado?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers});
    }

    obtenerProductos(){
       
        let headers = this.header;
        return this.http.get(`${this.urlBase}/Productos?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
    }
}